<template>
  <div :class="{
    'slo-tooltip': true,
    'slo-tooltip--inset': inset,
    [`slo-tooltip--inset-${insetDirection}`]: inset
  }">
    <slot></slot>
    <div
      v-if="enabled"
      v-html="text"
      :class="{
        'slo-tooltip--text': true,
        [`slo-tooltip--position--${position}`]: true
      }"
    />
  </div>
</template>

<script>
export default {
  name: 'SloTooltip',
  props: {
    enabled: {type: Boolean, default: true},
    text: {type: String, required: true},
    position: {type: String, default: 'top'},
    inset: {type: Boolean, default: false},
    insetDirection: {type: String, default: 'right'}
  }
};
</script>

<style lang="scss" scoped>
@import '../../scss/variables';
@import '../../scss/system';

.slo-tooltip {
  --inset-x: 16px;
  --position-xy-distance: 50%;
  --top: auto;
  --right: auto;
  --bottom: auto;
  --left: auto;
  --margin-top: 0;
  --margin-right: 0;
  --margin-bottom: 0;
  --margin-left: 0;

  position: relative;
  display: inline-block;

  &--inset {
    position: absolute;
    top: var(--position-xy-distance);
    transform: translateY(calc(var(--position-xy-distance) * -1));
  }
  &--inset-right {
    right: var(--inset-x);
  }
  &--inset-left {
    left: var(--inset-x);
  }

  &:hover {
    .slo-tooltip--text {
      opacity: 1;
    }
  }

  &--text {
    position: absolute;
    top: var(--top);
    right: var(--right);
    bottom: var(--bottom);
    left: var(--left);
    background-color: $color-gray-900;
    color: $color-white;
    font-size: 14px;
    font-weight: normal;
    padding: 5px 8px;
    margin: var(--margin-top) var(--margin-right) var(--margin-bottom) var(--margin-left);
    border-radius: 4px;
    width: max-content;
    max-width: 300px;
    white-space: normal;
    pointer-events: none;
    word-wrap: break-word;
    z-index: 1000;
    opacity: 0;
    transition: opacity 0.25s ease-in-out;
  }

  &--position--top {
    --bottom: 100%;
    --left: 0;
    --margin-bottom: 5px;

    @media (min-width: $screen-lg-min) {
      --left: 50%;

      transform: translateX(calc(var(--left) * -1));
    }
  }
  &--position--top-right {
    --bottom: 100%;
    --right: 0;
    --margin-bottom: 5px;

    @media (min-width: $screen-lg-min) {
      --right: 50%;

      transform: translateX(var(--right));
    }
  }
  &--position--right {
    --top: 50%;
    --right: 0;
    --margin-left: 5px;

    transform: translateY(calc(var(--top) * -1));
  }
  &--position--bottom {
    --top: 100%;
    --left: 0;
    --margin-top: 5px;

    @media (min-width: $screen-lg-min) {
      --left: 50%;

      transform: translateX(calc(var(--left) * -1));
    }
  }
  &--position--bottom-right {
    --top: 100%;
    --right: 0;
    --margin-top: 5px;

    @media (min-width: $screen-lg-min) {
      --right: 50%;

      transform: translateX(var(--right));
    }
  }
  &--position--left {
    --top: 50%;
    --left: 0;
    --margin-right: 5px;

    transform: translateY(calc(var(--top) * -1));
  }
}
</style>
